import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';


export const createPost= async (formData: FormData) => {
  try {
    const response = await axios.post(`${API_URL}/Post/create-post`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}` 
      },
    });
    return response;
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};

export const getAllPosts = async () => {
  try{
    const response = await axios.get(`${API_URL}/Post/get-all-posts`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}` 
      },
    });
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return [];

  }
};

export const getClientsPosts = async () => {
  try{
    const response = await axios.get(`${API_URL}/Post/get-clients-posts`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}` 
      },
    });
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return [];

  }
};


export const getImageUrl = async (formData: FormData) => {
  try {
    const response = await axios.post(`${API_URL}/Post/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      },
    });

    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    return null; 
  }
};

export const updatePostContent = async (postId: number, content: string) => {
  try {
    const response = await axios.put(
      `${API_URL}/Post/update-content`,
      { postId, Content: content }, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    throw error;
  }
};

export const updatePostContacts = async (
  postId: number,
  contactName: string,
  contactType: string,
  contactPhone: string
) => {
  try {
    const response = await axios.put(
      `${API_URL}/Post/update-contacts`,
      { postId, ContactName: contactName, ContactType: contactType, ContactPhone: contactPhone }, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    handleAuthError(error);
    throw error;
  }
};

export const deletePost = async (postId: number) => {
  try {
    const response = await axios.delete(`${API_URL}/Post/delete-post/${postId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    return response; 
  } catch (error: any) {
    handleAuthError(error);
    return undefined;
  }
};



const handleAuthError = (error: any) => {
    console.log(error);
    if (error.response) {
      throw new Error(error.response.data.message || error.message); 
    } else {
      throw new Error(error.message || 'An unknown error occurred');
    }
  };
  